<template>
  <div class="form-control d-flex flex-wrap h-auto">
    <div
      :key="index"
      class="item d-flex justify-content-between"
      v-for="(tag, index) in value"
    >
      <span class="name">{{ tag.name }}</span>
      <b-btn size="sm" variant="link" @click="remove(index)">×</b-btn>
    </div>
    <b-input
      size="sm"
      class="input"
      @compositionstart.native="composing = true"
      @compositionend.native="composing = false"
      @input.native="handleInput"
      @keydown.native.tab.enter="handleSpecialCharacter"
      @keydown.native.8="del"
      placeholder="태그"
      ref="input"
    />
  </div>
</template>

<script>
function TagAlreadyExistsError() {
  this.name = "TagAlreadyExistsError";
}

export default {
  props: {
    value: { required: true },
    max: { default: 10 }
  },
  data() {
    return {
      tags: null,
      tagSet: null,
      input: "",
      composing: false
    };
  },
  watch: {
    value: {
      handler() {
        if (this.value === undefined) {
          return;
        }

        if (this.value === this.tags) {
          return;
        }

        this.tags = [];
        this.tagSet = new Set();
        this.addTags(this.value);
      },
      immediate: true
    }
  },
  methods: {
    handleInput(event) {
      if (!event.data) {
        this.input = event.target.value;
        return;
      }

      const code = event.data[event.data.length - 1];
      if (code === " " || code === ",") {
        const tags = event.target.value.split(code).filter(value => value);
        this.addTags(tags);
      }

      this.input = event.target.value;
    },
    handleSpecialCharacter(event) {
      if (this.composing) {
        return;
      }

      if (!event.target.value) {
        return;
      }

      event.preventDefault();
      this.addTags([event.target.value]);
      this.input = event.target.value;
    },
    push(tag) {
      if (this.tags.length >= this.max) {
        throw new RangeError();
      }

      if (!tag) {
        throw new ReferenceError();
      }

      if (typeof tag === "string") {
        tag = { name: tag };
      }

      if (this.tagSet.has(tag.name)) {
        throw new TagAlreadyExistsError();
      }

      this.tags.push(tag);
      this.tagSet.add(tag.name);
      this.$emit("input", this.tags);
    },
    pop() {
      this.remove(this.tags.length - 1);
    },
    remove(index) {
      let tag = this.tags.splice(index, 1)[0];
      if (!tag) {
        return;
      }

      this.tagSet.delete(tag.name);
      this.$emit("input", this.tags);
    },
    addTags(tags) {
      const failed = [];

      if (!tags) {
        return failed;
      }

      tags.forEach(tag => {
        if (tag.length > 20) {
          this.$bvModal.msgBoxOk(
            [
              this.$createElement("p", "태그가 너무 깁니다."),
              this.$createElement("p", "One or more of your tags are too long.")
            ],
            {
              centered: true
            }
          );
          failed.push(tag);
          return;
        }

        try {
          this.push(tag);
        } catch (e) {
          if (e instanceof RangeError) {
            this.$bvModal.msgBoxOk(
              [
                this.$createElement("p", "태그는 10개까지 입력 가능합니다."),
                this.$createElement("p", "There are too many tags.")
              ],
              {
                centered: true
              }
            );
            return;
          } else if (e instanceof TagAlreadyExistsError) {
            return;
          }

          failed.push(tag);
        }
      });

      if (this.$refs.input) {
        this.$nextTick(() => {
          this.input = this.$refs.input.$el.value = failed.join("");
        });
      }
    },
    del() {
      if (this.input) {
        return;
      }

      this.pop();
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  font-size: 10px;
  max-width: 100%;
  margin: 0px 2px 3px 0px;
  padding: 0 4px;
  border: 1px solid #eaeaea;
  border-radius: 20px;

  .name {
    overflow: hidden;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 1px;
  }

  .btn-link {
    color: #495057;
    padding: 0px;
    border: 0;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.badge {
  font-size: 10px;
  line-height: 10px;
  margin-right: 3px;
}

.input {
  border: none;
  box-shadow: none;
  padding: 0;
  margin: 2px 0px;
}
</style>
